import React, { FC, useCallback } from 'react';
import { Navigate, Route, Routes as SwitchRoutes, useNavigate } from 'react-router-dom';
import { Routes } from 'constants/route.constants';
import Main from 'modules/authentication/Main';
import BookingShared from 'modules/booking/containers/BookingShared/BookingShared';
import {
  CookiePolicyContainer,
  PrivacyPolicyContainer,
  TermsOfServiceContainer,
} from 'modules/privacy-policy/containers';

const PublicRoutes: FC = () => {
  const navigate = useNavigate();

  const onBack = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <SwitchRoutes>
      <Route path={Routes.BOOKING_SHARED} element={<BookingShared />} />
      <Route path={Routes.PRIVACY_POLICY} element={<PrivacyPolicyContainer onBack={onBack} />} />
      <Route path={Routes.COOKIE_POLICY} element={<CookiePolicyContainer onBack={onBack} />} />
      <Route path={Routes.TERMS_OF_SERVICE} element={<TermsOfServiceContainer onBack={onBack} />} />
      <Route path={Routes.SIGN_IN} element={<Main />} />
      <Route path="*" element={<Navigate replace to={Routes.SIGN_IN} />} />
    </SwitchRoutes>
  );
};

export default PublicRoutes;
